import { useInventoryQuery } from '__generated__/graphql';
import { isServer } from 'utils/constants';

import { useIsCrawler } from './useIsCrawler';

export const useInventory = (productId?: string) => {
  const isCrawler = useIsCrawler();
  const inventory = useInventoryQuery({
    variables: { id: productId as string },
    pause: !productId || (isServer && !isCrawler),
    requestPolicy: 'network-only',
  });
  return inventory;
};
